import styled from 'styled-components';

export const ButtonWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 5.2rem;
`;
